# Used in SME credit. As there's two responsive layouts (left-right vs top-bottom), it properly resizes the bubbles,
# once the screen resolution changes.

DESKTOP_WIDTH = 1023
BUBBLES_CLASS_WILDCARD = 'bubbles-type-'

# dimensions for the bubbles wrapper element, according to the kind of bubbles
DIMENSIONS =
  'sector':
    desktop: [575, 390]
    mobile: [353, 378]
  'amount':
    desktop: [575, 390]
    mobile: [353, 378]
  'offer-1':
    desktop: [577, 459]
    mobile: [325, 446]
  'offer-2':
    desktop: [577, 606]
    mobile: [325, 547]
  'offer-3':
    desktop: [577, 649]
    mobile: [325, 755]

resizeBubbles = ->
  $('[data-behaviour="bubble-resizer"]').each ->
    $el = $ @
    matches = $el.attr('class').match(///#{BUBBLES_CLASS_WILDCARD}(\S+)///)
    if matches? && (key = matches[1])?
      if($(window).width() > DESKTOP_WIDTH)
        $el.width(DIMENSIONS[key].desktop[0]).height(DIMENSIONS[key].desktop[1])
      else
        $el.width(DIMENSIONS[key].mobile[0]).height(DIMENSIONS[key].mobile[1])

$(document).ready(resizeBubbles)

$(window).on 'resize.bubbles orientationchange.bubbles', resizeBubbles
